import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { format } from 'owa-strings';

export default function getTodoRequestHeaders() {
    const userConfiguration = getUserConfiguration();
    const userTimeZone = userConfiguration.UserOptions.TimeZone;
    const timezonePreferHeader = format('outlook.timezone="{0}"', userTimeZone);
    return {
        Prefer: timezonePreferHeader,
    };
}
